import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Pagination,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { listAdminPublications, AdminPublicationListResponse, AdminPublication } from '../../services/actaAdminPublicationsService';
import swal from 'sweetalert';

const AdminPublicationsList: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<AdminPublicationListResponse | null>(null);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState<number>(1);
  const [limit] = useState<number>(5); // Exemplo

  const fetchData = async () => {
    setLoading(true);
    try {
      // entityId é opcional. Se quiser, busque do Redux, de um Select etc.
      const result = await listAdminPublications(undefined, page, limit);
      setData(result);
    } catch (error) {
      console.error('Erro ao listar publicações admin:', error);
      swal('Erro', 'Não foi possível listar as publicações (admin).', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const handlePageChange = (_e: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
  };

  const handleRowClick = (pubId: string) => {
    navigate(`/publicacoes-admin/${pubId}`);
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5">Publicações (Admin)</Typography>
        <Button variant="contained" onClick={() => navigate('/publicacoes-admin/novo')}>
          Nova Publicação
        </Button>
      </Box>

      {!data ? (
        <Typography>Nenhuma informação carregada.</Typography>
      ) : (
        <>
          {data.items.length === 0 ? (
            <Typography>Nenhuma publicação encontrada.</Typography>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Entidade</TableCell> {/* Nova coluna */}
                    <TableCell>Título</TableCell>
                    <TableCell>Resumo</TableCell>
                    <TableCell>Publicado em</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.items.map((pub: AdminPublication) => (
                    <TableRow
                      key={pub.id}
                      hover
                      sx={{ cursor: 'pointer' }}
                      onClick={() => handleRowClick(pub.id)}
                    >
                      <TableCell>{pub.id}</TableCell>
                      <TableCell>
                        {/* Exibe prefix + suffix (ou algo similar) caso exista entity */}
                        {pub.entity
                          ? `${pub.entity.prefix} ${pub.entity.suffix}`
                          : '—'}
                      </TableCell>
                      <TableCell>{pub.title || '—'}</TableCell>
                      <TableCell>{pub.summary || '—'}</TableCell>
                      <TableCell>{pub.published_at || '—'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Pagination
              page={data.page}
              count={Math.ceil(data.total / data.limit)}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default AdminPublicationsList;